/**
 * @file: fonts.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export const FontFamily = {
  NotoSans: {
    Thin: 'NotoSansSC-Thin',
    Light: 'NotoSansSC-Light',
    Regular: 'NotoSansSC-Regular',
    Medium: 'NotoSansSC-Medium',
    Bold: 'NotoSansSC-Bold',
    Black: 'NotoSansSC-Black',
  },
};
